export const baseUrl = "https://backendattppc03.mobifonehaiphong.vn/attppc03"
//export const baseUrl = "http://localhost:6005"
//export const baseUrl = "https://api-bhtt.mobifone5.vn/api-bhtt"
//export const baseUrl = "https://apiungdunganm.haiduong.gov.vn/anm"
export default {
    baseUrl
}
